/* tslint:disable */
/* eslint-disable */
/**
 * B2B Auth
 * Authentication API  # Tracking Metrics * `b2bportal.auth.session.create.failure`   * tags: `api_version`, `auth_method`, `error_code`, `is_merge`, `new_user`, `tenantid` * `b2bportal.auth.session.create.success`   * tags: `api_version`, `auth_method`, `is_merge`, `new_user`, `tenantid` * `b2bportal.auth.session.info.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.session.info.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.session.refresh.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.session.refresh.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.session.remove.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.session.remove.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.session.verify.failure`   * tags: `error_code`, `tenantid` * `b2bportal.auth.session.verify.latency`   * tags: `tenantid` * `b2bportal.auth.session.verify.success`   * tags: `tenantid` * `b2bportal.auth.user.finalized.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.user.finalized.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.user.info.update.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.user.info.update.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.verification_code.resend.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.verification_code.resend.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.verification_code.send.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.verification_code.send.success`   * tags: `api_version`, `tenantid`   # Tracking Error Codes * `already_finalized` * `authentication_method_not_implemented` * `bad_request` * `booking_scope_required` * `cannot_finalize_guest` * `deleted_user` * `email_taken` * `existing_session_token` * `existing_session` * `expired_code` * `expired_token` * `ineligible` * `internal_error` * `invalid_code` * `invalid_email` * `invalid_hash` * `invalid_id` * `invalid_phone_number` * `invalid_token` * `malformed_session` * `merged_user` * `no_session_token` * `not_verified` * `phone_number_taken` * `price_watch_scope_required` * `rejected_session` * `request_deserialization_error` * `response_serialization_error` * `send_failed` * `server_error` * `too_many_user_for_device` * `unauthorized` * `unknown` * `user_does_not_exist` * `user_not_found`  
 *
 * The version of the OpenAPI document: v0p40
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Agent login on behalf of a user.

 * `user` - The user being impersonated
 * `tenant` - Tenant the user belongs to
 * @export
 * @interface Agent
 */
export interface Agent {
    /**
     * The user being impersonated
     * @type {string}
     * @memberof Agent
     */
    'user': string;
    /**
     * Tenant the user belongs to
     * @type {string}
     * @memberof Agent
     */
    'tenant'?: string;
    'AuthMethod': AuthMethodEnum;
}


/**
 * Login as an anonymous user. A new anonymous user will be created and a session will be returned for that user. Should not be used when used when there is already an existing session. If a session cookie is used on requestwith `Anonymous` `authMethod` the request will fail.
 * @export
 * @interface Anonymous
 */
export interface Anonymous {
    'locale': string;
    'timezone'?: string;
    'AuthMethod': AuthMethodEnum;
}


/**
 * Login as an anonymous user from the Hopper App that has a userId but does not have an accessToken. The userId specified must be anonymous and should only be used when the hopper app does not have an accessToken. If a session cookie is used on request with `Anonymous` `authMethod` the request will fail.
 * @export
 * @interface AnonymousHopperApp
 */
export interface AnonymousHopperApp {
    'locale': string;
    'timezone'?: string;
    'userId': string;
    'AuthMethod': AuthMethodEnum;
}


/**
 * @type AuthMethod
 * The method of authentication
 * @export
 */
export type AuthMethod = { AuthMethod: 'Agent' } & Agent | { AuthMethod: 'Anonymous' } & Anonymous | { AuthMethod: 'AnonymousHopperApp' } & AnonymousHopperApp | { AuthMethod: 'GoogleIdentityBased' } & GoogleIdentityBased | { AuthMethod: 'PartnerToken' } & PartnerToken | { AuthMethod: 'VerifyCode' } & VerifyCode;

export const AuthMethodEnum = {
    Agent: 'Agent',
    Anonymous: 'Anonymous',
    AnonymousHopperApp: 'AnonymousHopperApp',
    GoogleIdentityBased: 'GoogleIdentityBased',
    PartnerToken: 'PartnerToken',
    VerifyCode: 'VerifyCode'
} as const;

export type AuthMethodEnum = typeof AuthMethodEnum[keyof typeof AuthMethodEnum];


export interface BookingAvailable {
    'BookingScope': BookingScopeEnum;
}


/**
 * @type BookingScope
 * Determines if booking available for this user
 * @export
 */
export type BookingScope = { BookingScope: 'BookingAvailable' } & BookingAvailable | { BookingScope: 'BookingUnavailable' } & BookingUnavailable;

export const BookingScopeEnum = {
    BookingAvailable: 'BookingAvailable',
    BookingUnavailable: 'BookingUnavailable'
} as const;

export type BookingScopeEnum = typeof BookingScopeEnum[keyof typeof BookingScopeEnum];


export interface BookingUnavailable {
    'BookingScope': BookingScopeEnum;
}


/**
 * Creating a session failed.
 * @export
 * @interface CreateSessionFailed
 */
export interface CreateSessionFailed {
    'reason': CreateSessionFailureReason;
    'CreateSessionResponse': CreateSessionResponseEnum;
}


export const CreateSessionFailureReason = {
    AuthenticationMethodNotImplemented: 'AuthenticationMethodNotImplemented',
    ExistingSession: 'ExistingSession',
    ExpiredCode: 'ExpiredCode',
    ExpiredToken: 'ExpiredToken',
    InvalidCode: 'InvalidCode',
    InvalidEmail: 'InvalidEmail',
    InvalidHash: 'InvalidHash',
    InvalidId: 'InvalidId',
    InvalidPhoneNumber: 'InvalidPhoneNumber',
    InvalidToken: 'InvalidToken',
    ServerError: 'ServerError',
    TooManyUserForDevice: 'TooManyUserForDevice',
    UserDoesNotExist: 'UserDoesNotExist'
} as const;

export type CreateSessionFailureReason = typeof CreateSessionFailureReason[keyof typeof CreateSessionFailureReason];


/**
 * @type CreateSessionRequest
 * Request to create a session.
 * @export
 */
export type CreateSessionRequest = { CreateSessionRequest: 'Finalized' } & Finalized | { CreateSessionRequest: 'Guest' } & Guest | { CreateSessionRequest: 'Merge' } & Merge | { CreateSessionRequest: 'SignIn' } & SignIn;

export const CreateSessionRequestEnum = {
    Finalized: 'Finalized',
    Guest: 'Guest',
    Merge: 'Merge',
    SignIn: 'SignIn'
} as const;

export type CreateSessionRequestEnum = typeof CreateSessionRequestEnum[keyof typeof CreateSessionRequestEnum];


/**
 * @type CreateSessionResponse
 * @export
 */
export type CreateSessionResponse = { CreateSessionResponse: 'CreateSessionFailed' } & CreateSessionFailed | { CreateSessionResponse: 'CreateSessionSuccess' } & CreateSessionSuccess | { CreateSessionResponse: 'FinalizedRequired' } & FinalizedRequired;

export const CreateSessionResponseEnum = {
    CreateSessionFailed: 'CreateSessionFailed',
    CreateSessionSuccess: 'CreateSessionSuccess',
    FinalizedRequired: 'FinalizedRequired'
} as const;

export type CreateSessionResponseEnum = typeof CreateSessionResponseEnum[keyof typeof CreateSessionResponseEnum];


/**
 * User successfully signed in. The session cookie is updated with new session.

 * `previousUserTracking` - Since createSession changes the session user, `previousUserTracking` should be passed to `userOverride`in tracking request when tracking auth events.
 * @export
 * @interface CreateSessionSuccess
 */
export interface CreateSessionSuccess {
    /**
     * Since createSession changes the session user, `previousUserTracking` should be passed to `userOverride`in tracking request when tracking auth events.
     * @type {string}
     * @memberof CreateSessionSuccess
     */
    'previousUserTracking'?: string;
    'CreateSessionResponse': CreateSessionResponseEnum;
}


/**
 * Finalizing the user has failed
 * @export
 * @interface FinalizeUserFailure
 */
export interface FinalizeUserFailure {
    'reason': FinalizeUserFailureReason;
    'FinalizeUserResponse': FinalizeUserResponseEnum;
}


export const FinalizeUserFailureReason = {
    AlreadyFinalized: 'AlreadyFinalized',
    CannotFinalizeGuest: 'CannotFinalizeGuest',
    EmailTaken: 'EmailTaken',
    ExpiredToken: 'ExpiredToken',
    InvalidEmail: 'InvalidEmail',
    InvalidId: 'InvalidId',
    InvalidPhoneNumber: 'InvalidPhoneNumber',
    InvalidToken: 'InvalidToken',
    NotVerified: 'NotVerified',
    PhoneNumberTaken: 'PhoneNumberTaken',
    ServerError: 'ServerError'
} as const;

export type FinalizeUserFailureReason = typeof FinalizeUserFailureReason[keyof typeof FinalizeUserFailureReason];


/**
 * Add additional details to user before creating an account an receiving a session can be completed

 * `authStateToken` - The auth state. The state from the previous request made.
 * @export
 * @interface FinalizeUserRequest
 */
export interface FinalizeUserRequest {
    /**
     * A phone Number. The frontend should validate the phone number since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof FinalizeUserRequest
     */
    'phoneNumber'?: string;
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof FinalizeUserRequest
     */
    'email'?: string;
    'lastName': string;
    'firstName': string;
    /**
     * The auth state. The state from the previous request made.
     * @type {string}
     * @memberof FinalizeUserRequest
     */
    'authStateToken': string;
}
/**
 * @type FinalizeUserResponse
 * The result of finalizing the user
 * @export
 */
export type FinalizeUserResponse = { FinalizeUserResponse: 'FinalizeUserFailure' } & FinalizeUserFailure | { FinalizeUserResponse: 'FinalizeUserSuccess' } & FinalizeUserSuccess | { FinalizeUserResponse: 'MatchingAccountsFound' } & MatchingAccountsFound;

export const FinalizeUserResponseEnum = {
    FinalizeUserFailure: 'FinalizeUserFailure',
    FinalizeUserSuccess: 'FinalizeUserSuccess',
    MatchingAccountsFound: 'MatchingAccountsFound'
} as const;

export type FinalizeUserResponseEnum = typeof FinalizeUserResponseEnum[keyof typeof FinalizeUserResponseEnum];


/**
 * The user is successfully finalized. Call `createSession` with `Finalized` request

 * `authStateToken` - The auth state. The state should be passed to next request made.
 * @export
 * @interface FinalizeUserSuccess
 */
export interface FinalizeUserSuccess {
    /**
     * The auth state. The state should be passed to next request made.
     * @type {string}
     * @memberof FinalizeUserSuccess
     */
    'authStateToken': string;
    'FinalizeUserResponse': FinalizeUserResponseEnum;
}


/**
 * User has been finalized with the `finalize` endpoint

 * `authStateToken` - The auth state. The state from the previous request made.
 * @export
 * @interface Finalized
 */
export interface Finalized {
    /**
     * The auth state. The state from the previous request made.
     * @type {string}
     * @memberof Finalized
     */
    'authStateToken': string;
    'CreateSessionRequest': CreateSessionRequestEnum;
}


/**
 * User is successfully verified, but since it is a new account it will need additional information before being logged in. Call the `finalize` endpoint to add the additional details to the user account. Once it is finalized, call `createSession` with a `Finalized` request to receive session.

 * `authStateToken` - The auth state. The state should be passed to next request made.
 * @export
 * @interface FinalizedRequired
 */
export interface FinalizedRequired {
    /**
     * The auth state. The state should be passed to next request made.
     * @type {string}
     * @memberof FinalizedRequired
     */
    'authStateToken': string;
    'missingFields': Array<UserInfoField>;
    'CreateSessionResponse': CreateSessionResponseEnum;
}


/**
 * @type GetSessionInfoResponse
 * Get session info result
 * @export
 */
export type GetSessionInfoResponse = { GetSessionInfoResponse: 'NoSession' } & NoSession | { GetSessionInfoResponse: 'Session' } & Session | { GetSessionInfoResponse: 'SessionRejected' } & SessionRejected;

export const GetSessionInfoResponseEnum = {
    NoSession: 'NoSession',
    Session: 'Session',
    SessionRejected: 'SessionRejected'
} as const;

export type GetSessionInfoResponseEnum = typeof GetSessionInfoResponseEnum[keyof typeof GetSessionInfoResponseEnum];


/**
 * Login using Google SSO. previous state should only be populated during Merge requests.
 * @export
 * @interface GoogleIdentityBased
 */
export interface GoogleIdentityBased {
    'previousAuthStateToken'?: string;
    'idToken': string;
    'AuthMethod': AuthMethodEnum;
}


/**
 * Update user to a "guest" user where they can make a booking, but cannot sign back into the same account.

 * `givenName` - Users first name, not used for the booking but required for certain downstream dependencies.
 * `surname` - Users last name, not used for the booking but required for certain downstream dependencies.
 * `email` - The contact email used for the user if no product email set. This email will not be validated.
 * `phoneNumber` - The contact phone number used for the user if no product phone number set. This phone number will not be validated.
 * @export
 * @interface Guest
 */
export interface Guest {
    /**
     * Users first name, not used for the booking but required for certain downstream dependencies.
     * @type {string}
     * @memberof Guest
     */
    'givenName': string;
    /**
     * A phone Number. The frontend should validate the phone number since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof Guest
     */
    'phoneNumber': string;
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof Guest
     */
    'email': string;
    /**
     * Users last name, not used for the booking but required for certain downstream dependencies.
     * @type {string}
     * @memberof Guest
     */
    'surname': string;
    'CreateSessionRequest': CreateSessionRequestEnum;
}


export const MatchCondition = {
    Email: 'Email',
    Phone: 'Phone'
} as const;

export type MatchCondition = typeof MatchCondition[keyof typeof MatchCondition];


/**
 * An account matching the email or phone number added to the account. The user should merge accounts to prevent duplicate accounts. Next steps are: - To verify merge via a verification code: Make `sendCode` endpoint with a `SendCodeForMerge` request then call `createSession` with a `Merge` request to verify the code and merge the accounts - To verify merge via SSO call `createSession` with a `Merge` request with an SSO `authMethod` to merge the accounts

 * `authStateToken` - The auth state. The state should be passed to next request made.
 * @export
 * @interface MatchingAccountsFound
 */
export interface MatchingAccountsFound {
    /**
     * The auth state. The state should be passed to next request made.
     * @type {string}
     * @memberof MatchingAccountsFound
     */
    'authStateToken': string;
    'userMatch': UserMatch;
    'FinalizeUserResponse': FinalizeUserResponseEnum;
}


/**
 * Request to merge an account. Used to verify an account for merging after user matches were detected in finalize response.
 * @export
 * @interface Merge
 */
export interface Merge {
    'authMethod': AuthMethod;
    'CreateSessionRequest': CreateSessionRequestEnum;
}


/**
 * No valid session token on request
 * @export
 * @interface NoSession
 */
export interface NoSession {
    'GetSessionInfoResponse': GetSessionInfoResponseEnum;
}


/**
 * Auth token obtained from partner

 * `token` - The partner auth token
 * `partnerDetails` - Additional opaque partner specific auth data
 * @export
 * @interface PartnerToken
 */
export interface PartnerToken {
    /**
     * The partner auth token
     * @type {string}
     * @memberof PartnerToken
     */
    'token'?: string;
    /**
     * Additional opaque partner specific auth data
     * @type {any}
     * @memberof PartnerToken
     */
    'partnerDetails'?: any;
    'AuthMethod': AuthMethodEnum;
}


export interface PriceWatchAvailable {
    'PriceWatchScope': PriceWatchScopeEnum;
}


/**
 * @type PriceWatchScope
 * Determines if Price Watch is available for this user
 * @export
 */
export type PriceWatchScope = { PriceWatchScope: 'PriceWatchAvailable' } & PriceWatchAvailable | { PriceWatchScope: 'PriceWatchUnavailable' } & PriceWatchUnavailable;

export const PriceWatchScopeEnum = {
    PriceWatchAvailable: 'PriceWatchAvailable',
    PriceWatchUnavailable: 'PriceWatchUnavailable'
} as const;

export type PriceWatchScopeEnum = typeof PriceWatchScopeEnum[keyof typeof PriceWatchScopeEnum];


export interface PriceWatchUnavailable {
    'PriceWatchScope': PriceWatchScopeEnum;
}


/**
 * Failed to refresh session
 * @export
 * @interface RefreshSessionFailure
 */
export interface RefreshSessionFailure {
    'reason': RefreshSessionFailureReason;
    'RefreshSessionResponse': RefreshSessionResponseEnum;
}


export const RefreshSessionFailureReason = {
    NotAuthorized: 'NotAuthorized'
} as const;

export type RefreshSessionFailureReason = typeof RefreshSessionFailureReason[keyof typeof RefreshSessionFailureReason];


/**
 * Request session refresh using refresh token
 * @export
 * @interface RefreshSessionRequest
 */
export interface RefreshSessionRequest {
    'refreshToken': string;
}
/**
 * @type RefreshSessionResponse
 * Request session result
 * @export
 */
export type RefreshSessionResponse = { RefreshSessionResponse: 'RefreshSessionFailure' } & RefreshSessionFailure | { RefreshSessionResponse: 'RefreshSessionSuccess' } & RefreshSessionSuccess;

export const RefreshSessionResponseEnum = {
    RefreshSessionFailure: 'RefreshSessionFailure',
    RefreshSessionSuccess: 'RefreshSessionSuccess'
} as const;

export type RefreshSessionResponseEnum = typeof RefreshSessionResponseEnum[keyof typeof RefreshSessionResponseEnum];


/**
 * Session cookie is updated and new refresh token is returned in headers
 * @export
 * @interface RefreshSessionSuccess
 */
export interface RefreshSessionSuccess {
    'RefreshSessionResponse': RefreshSessionResponseEnum;
}


/**
 * Removing session failed.
 * @export
 * @interface RemoveSessionFailure
 */
export interface RemoveSessionFailure {
    'reason': RemoveSessionReason;
    'RemoveSessionResponse': RemoveSessionResponseEnum;
}


export const RemoveSessionReason = {
    NotAuthorized: 'NotAuthorized'
} as const;

export type RemoveSessionReason = typeof RemoveSessionReason[keyof typeof RemoveSessionReason];


/**
 * @type RemoveSessionResponse
 * Remove session. A successful response will delete session cookie.
 * @export
 */
export type RemoveSessionResponse = { RemoveSessionResponse: 'RemoveSessionFailure' } & RemoveSessionFailure | { RemoveSessionResponse: 'RemoveSessionSuccess' } & RemoveSessionSuccess;

export const RemoveSessionResponseEnum = {
    RemoveSessionFailure: 'RemoveSessionFailure',
    RemoveSessionSuccess: 'RemoveSessionSuccess'
} as const;

export type RemoveSessionResponseEnum = typeof RemoveSessionResponseEnum[keyof typeof RemoveSessionResponseEnum];


/**
 * Session successfully removed and session cookie is deleted.
 * @export
 * @interface RemoveSessionSuccess
 */
export interface RemoveSessionSuccess {
    'RemoveSessionResponse': RemoveSessionResponseEnum;
}


export interface ResendCodeFailed {
    'message'?: string;
    'ResendCodeResponse': ResendCodeResponseEnum;
}


/**
 * Resend a verification code with alternative method for account recovery.

 * `authStateToken` - The auth state. The state from the previous request made.
 * @export
 * @interface ResendCodeRequest
 */
export interface ResendCodeRequest {
    /**
     * The auth state. The state from the previous request made.
     * @type {string}
     * @memberof ResendCodeRequest
     */
    'authStateToken': string;
    'user': UserKey;
    'verificationMethod': VerificationMethod;
}


/**
 * @type ResendCodeResponse
 * Resend verification code result
 * @export
 */
export type ResendCodeResponse = { ResendCodeResponse: 'ResendCodeFailed' } & ResendCodeFailed | { ResendCodeResponse: 'ResendCodeSucceeded' } & ResendCodeSucceeded;

export const ResendCodeResponseEnum = {
    ResendCodeFailed: 'ResendCodeFailed',
    ResendCodeSucceeded: 'ResendCodeSucceeded'
} as const;

export type ResendCodeResponseEnum = typeof ResendCodeResponseEnum[keyof typeof ResendCodeResponseEnum];


/**
 * `authStateToken` - The auth state. The state should be passed to next request made.
 * @export
 * @interface ResendCodeSucceeded
 */
export interface ResendCodeSucceeded {
    /**
     * The auth state. The state should be passed to next request made.
     * @type {string}
     * @memberof ResendCodeSucceeded
     */
    'authStateToken': string;
    'ResendCodeResponse': ResendCodeResponseEnum;
}


/**
 * Send verification code to email address
 * @export
 * @interface SendCodeEmail
 */
export interface SendCodeEmail {
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof SendCodeEmail
     */
    'email': string;
    'SendCodeRequest': SendCodeRequestEnum;
}


export interface SendCodeFailed {
    'reason': SendCodeFailureReason;
    'message'?: string;
    'SendCodeResponse': SendCodeResponseEnum;
}


export const SendCodeFailureReason = {
    ExpiredToken: 'ExpiredToken',
    InvalidEmail: 'InvalidEmail',
    InvalidPhoneNumber: 'InvalidPhoneNumber',
    InvalidToken: 'InvalidToken',
    SendFailed: 'SendFailed',
    ServerError: 'ServerError',
    UserDoesNotExist: 'UserDoesNotExist'
} as const;

export type SendCodeFailureReason = typeof SendCodeFailureReason[keyof typeof SendCodeFailureReason];


/**
 * Send a verification code to the verified phone/email of an account you are merging. the `authStateToken` should be the one returned from the `MatchingAccountsFound` finalize response.

 * `authStateToken` - The auth state. The state from the previous request made.
 * @export
 * @interface SendCodeForMerge
 */
export interface SendCodeForMerge {
    /**
     * The auth state. The state from the previous request made.
     * @type {string}
     * @memberof SendCodeForMerge
     */
    'authStateToken': string;
    'SendCodeRequest': SendCodeRequestEnum;
}


/**
 * @type SendCodeRequest
 * Request a verification code be sent.
 * @export
 */
export type SendCodeRequest = { SendCodeRequest: 'SendCodeEmail' } & SendCodeEmail | { SendCodeRequest: 'SendCodeForMerge' } & SendCodeForMerge | { SendCodeRequest: 'SendCodeSms' } & SendCodeSms;

export const SendCodeRequestEnum = {
    SendCodeEmail: 'SendCodeEmail',
    SendCodeForMerge: 'SendCodeForMerge',
    SendCodeSms: 'SendCodeSms'
} as const;

export type SendCodeRequestEnum = typeof SendCodeRequestEnum[keyof typeof SendCodeRequestEnum];


/**
 * @type SendCodeResponse
 * The result of the a code send
 * @export
 */
export type SendCodeResponse = { SendCodeResponse: 'SendCodeFailed' } & SendCodeFailed | { SendCodeResponse: 'SendCodeSucceeded' } & SendCodeSucceeded;

export const SendCodeResponseEnum = {
    SendCodeFailed: 'SendCodeFailed',
    SendCodeSucceeded: 'SendCodeSucceeded'
} as const;

export type SendCodeResponseEnum = typeof SendCodeResponseEnum[keyof typeof SendCodeResponseEnum];


/**
 * Send verification code to phone number via sms
 * @export
 * @interface SendCodeSms
 */
export interface SendCodeSms {
    /**
     * A phone Number. The frontend should validate the phone number since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof SendCodeSms
     */
    'phone': string;
    'SendCodeRequest': SendCodeRequestEnum;
}


/**
 * `authStateToken` - The auth state. The state should be passed to next request made.
 * @export
 * @interface SendCodeSucceeded
 */
export interface SendCodeSucceeded {
    /**
     * The auth state. The state should be passed to next request made.
     * @type {string}
     * @memberof SendCodeSucceeded
     */
    'authStateToken': string;
    'verificationAlternative': VerificationAlternative;
    'SendCodeResponse': SendCodeResponseEnum;
}


/**
 * Valid Session is present
 * @export
 * @interface Session
 */
export interface Session {
    'sessionInfo': SessionInfo;
    'GetSessionInfoResponse': GetSessionInfoResponseEnum;
}


/**
 * Information about current session

 * `isFirstSession` - Is this the first session for a newly created user. Note that subsequent refreshes of the the session may remove value
 * @export
 * @interface SessionInfo
 */
export interface SessionInfo {
    /**
     * Is this the first session for a newly created user. Note that subsequent refreshes of the the session may remove value
     * @type {boolean}
     * @memberof SessionInfo
     */
    'isFirstSession'?: boolean;
    'userInfo': UserInfo;
    'userScope': UserScope;
    'delegatedTo'?: string;
}
/**
 * A session token is on request but the session has been rejected because the session is expired or closed
 * @export
 * @interface SessionRejected
 */
export interface SessionRejected {
    'GetSessionInfoResponse': GetSessionInfoResponseEnum;
}


/**
 * Request to sign-in or sign-up
 * @export
 * @interface SignIn
 */
export interface SignIn {
    'authMethod': AuthMethod;
    'CreateSessionRequest': CreateSessionRequestEnum;
}


export interface UpdateUserInfoFailure {
    'reason': UpdateUserInfoFailureReason;
    'UpdateUserInfoResponse': UpdateUserInfoResponseEnum;
}


export const UpdateUserInfoFailureReason = {
    InvalidEmail: 'InvalidEmail',
    InvalidPhoneNumber: 'InvalidPhoneNumber',
    NotVerified: 'NotVerified',
    ServerError: 'ServerError',
    UserDoesNotExist: 'UserDoesNotExist'
} as const;

export type UpdateUserInfoFailureReason = typeof UpdateUserInfoFailureReason[keyof typeof UpdateUserInfoFailureReason];


export interface UpdateUserInfoRequest {
    'firstName'?: string;
    'lastName'?: string;
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof UpdateUserInfoRequest
     */
    'email'?: string;
    /**
     * A phone Number. The frontend should validate the phone number since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof UpdateUserInfoRequest
     */
    'phoneNumber'?: string;
}
/**
 * @type UpdateUserInfoResponse
 * @export
 */
export type UpdateUserInfoResponse = { UpdateUserInfoResponse: 'UpdateUserInfoFailure' } & UpdateUserInfoFailure | { UpdateUserInfoResponse: 'UpdateUserInfoSuccess' } & UpdateUserInfoSuccess;

export const UpdateUserInfoResponseEnum = {
    UpdateUserInfoFailure: 'UpdateUserInfoFailure',
    UpdateUserInfoSuccess: 'UpdateUserInfoSuccess'
} as const;

export type UpdateUserInfoResponseEnum = typeof UpdateUserInfoResponseEnum[keyof typeof UpdateUserInfoResponseEnum];


export interface UpdateUserInfoSuccess {
    'UpdateUserInfoResponse': UpdateUserInfoResponseEnum;
}


/**
 * General information about the user

 * `email` - User's email
 * `partnerMetadata` - Partner specific metadata
 * `lastName` - User's last name
 * `firstName` - User's first name
 * `siftUserId` - Sift Alias Id
 * `defaultCurrency` - The default currency for a user based on their location. Used for multi-currency defaulting. Note this is not the user's selected currency.
 * `phone` - User's phone number
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * User's email
     * @type {string}
     * @memberof UserInfo
     */
    'email'?: string;
    /**
     * Partner specific metadata
     * @type {any}
     * @memberof UserInfo
     */
    'partnerMetadata'?: any;
    /**
     * User's last name
     * @type {string}
     * @memberof UserInfo
     */
    'lastName'?: string;
    /**
     * User's first name
     * @type {string}
     * @memberof UserInfo
     */
    'firstName'?: string;
    'userState': UserState;
    /**
     * Sift Alias Id
     * @type {string}
     * @memberof UserInfo
     */
    'siftUserId'?: string;
    /**
     * The default currency for a user based on their location. Used for multi-currency defaulting. Note this is not the user's selected currency.
     * @type {string}
     * @memberof UserInfo
     */
    'defaultCurrency'?: string;
    /**
     * User's phone number
     * @type {string}
     * @memberof UserInfo
     */
    'phone'?: string;
}


export const UserInfoField = {
    Email: 'Email',
    FirstName: 'FirstName',
    LastName: 'LastName',
    PhoneNumber: 'PhoneNumber'
} as const;

export type UserInfoField = typeof UserInfoField[keyof typeof UserInfoField];


/**
 * @type UserKey
 * @export
 */
export type UserKey = { UserKey: 'UserWithEmail' } & UserWithEmail | { UserKey: 'UserWithPhone' } & UserWithPhone;

export const UserKeyEnum = {
    UserWithEmail: 'UserWithEmail',
    UserWithPhone: 'UserWithPhone'
} as const;

export type UserKeyEnum = typeof UserKeyEnum[keyof typeof UserKeyEnum];


/**
 * Details on a existing matching account
 * @export
 * @interface UserMatch
 */
export interface UserMatch {
    'matchCondition': MatchCondition;
    'verifiedAuthMethods': Array<VerifiedAuthMethod>;
}


/**
 * It determines the user type and the functionality that is available for that user.
 * @export
 * @interface UserScope
 */
export interface UserScope {
    /**
     * Is user signed in? Set to false for Guests and Anonymous users
     * @type {boolean}
     * @memberof UserScope
     */
    'isSignedIn': boolean;
    'priceWatch': PriceWatchScope;
    'booking': BookingScope;
}
/**
 * The state of the user: - `Verified` - user has a method or signing in - `Guest` - user has entered unverified contact information but is not signed in - `Anonymous` - user is not signed in nor has not entered any contact information
 * @export
 * @enum {string}
 */

export const UserState = {
    Anonymous: 'Anonymous',
    Guest: 'Guest',
    Verified: 'Verified'
} as const;

export type UserState = typeof UserState[keyof typeof UserState];


export interface UserWithEmail {
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof UserWithEmail
     */
    'email': string;
    'UserKey': UserKeyEnum;
}


export interface UserWithPhone {
    /**
     * A phone Number. The frontend should validate the phone number since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof UserWithPhone
     */
    'phone': string;
    'UserKey': UserKeyEnum;
}


/**
 * Alternative ways to resend code for account recovery.
 * @export
 * @interface VerificationAlternative
 */
export interface VerificationAlternative {
    'redactedEmail'?: string;
    'redactedPhone'?: string;
}
/**
 * The method the code resend will use
 * @export
 * @enum {string}
 */

export const VerificationMethod = {
    VerifyByEmail: 'VerifyByEmail',
    VerifyByPhone: 'VerifyByPhone'
} as const;

export type VerificationMethod = typeof VerificationMethod[keyof typeof VerificationMethod];


/**
 * @type VerifiedAuthMethod
 * @export
 */
export type VerifiedAuthMethod = { VerifiedAuthMethod: 'VerifiedEmail' } & VerifiedEmail | { VerifiedAuthMethod: 'VerifiedPhone' } & VerifiedPhone | { VerifiedAuthMethod: 'VerifiedSso' } & VerifiedSso;

export const VerifiedAuthMethodEnum = {
    VerifiedEmail: 'VerifiedEmail',
    VerifiedPhone: 'VerifiedPhone',
    VerifiedSso: 'VerifiedSso'
} as const;

export type VerifiedAuthMethodEnum = typeof VerifiedAuthMethodEnum[keyof typeof VerifiedAuthMethodEnum];


export interface VerifiedEmail {
    'redactedEmail': string;
    'VerifiedAuthMethod': VerifiedAuthMethodEnum;
}


export interface VerifiedPhone {
    'redactedPhone': string;
    'VerifiedAuthMethod': VerifiedAuthMethodEnum;
}


export interface VerifiedSso {
    'maskedIdentity': string;
    'VerifiedAuthMethod': VerifiedAuthMethodEnum;
}


/**
 * Login by verifying a code sent via email or sms
 * @export
 * @interface VerifyCode
 */
export interface VerifyCode {
    'authStateToken': string;
    'code': string;
    'AuthMethod': AuthMethodEnum;
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Resend code that was triggered in previous call to `sendCode` endpoint. It can also be used for account recovery.  - To recover a user with a given phone number using their email: resend with `UserKey` of `UserWithPhone` and  a verification method of `VerifyByEmail`  - To recover a user with a given email using their phone number: resend with `UserKey` of `UserWithEmail` and  a verification method of `VerifyByPhone`
         * @param {ResendCodeRequest} resendCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthCodeResendPost: async (resendCodeRequest: ResendCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendCodeRequest' is not null or undefined
            assertParamExists('apiV0AuthCodeResendPost', 'resendCodeRequest', resendCodeRequest)
            const localVarPath = `/api/v0/auth/code/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start email/phone number verification. The endpoint takes in an email or phone number and will trigger a  verification code to be sent to user. The endpoint returns a `authStateToken`. Pass the  `authStateToken` along with the verification code that was sent to their email/phone number to  the `createSession` endpoint to receive a session for the user associated with that email or phone number.  Should not be automatically retried because it is not idempotent  
         * @param {SendCodeRequest} sendCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthCodeSendPost: async (sendCodeRequest: SendCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendCodeRequest' is not null or undefined
            assertParamExists('apiV0AuthCodeSendPost', 'sendCodeRequest', sendCodeRequest)
            const localVarPath = `/api/v0/auth/code/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify user identity through an authentication method. if verification is successful the session cookie will be updated.  may result in switching to another user or merging the anonymous session into an existing user. For example:  session cookie on call is anonymous user -> merges anonymous user into the verified user. replaces session cookie.  session cookie on call is verified user -> replace session cookie with new verified user  no session cookie -> failure  If `FinalizedRequired` is returned, finalize user with finalizeUser endpoint then get createSession with  returned `authStateToken`.
         * @param {CreateSessionRequest} createSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthSessionCreatePost: async (createSessionRequest: CreateSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSessionRequest' is not null or undefined
            assertParamExists('apiV0AuthSessionCreatePost', 'createSessionRequest', createSessionRequest)
            const localVarPath = `/api/v0/auth/session/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get information on current session 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthSessionInfoPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/auth/session/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refreshes session cookie 
         * @param {RefreshSessionRequest} refreshSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthSessionRefreshPut: async (refreshSessionRequest: RefreshSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshSessionRequest' is not null or undefined
            assertParamExists('apiV0AuthSessionRefreshPut', 'refreshSessionRequest', refreshSessionRequest)
            const localVarPath = `/api/v0/auth/session/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Perform log out for the current session. Removes session cookie. The createSession endpoint should be called right after log out so the user then has an anonymous user session to use the site. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthSessionRemovePut: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/auth/session/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finalize user by adding user information that was specified in createSession request
         * @param {FinalizeUserRequest} finalizeUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthUserFinalizePost: async (finalizeUserRequest: FinalizeUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'finalizeUserRequest' is not null or undefined
            assertParamExists('apiV0AuthUserFinalizePost', 'finalizeUserRequest', finalizeUserRequest)
            const localVarPath = `/api/v0/auth/user/finalize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(finalizeUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the core user properties. Should not be used to transition  user state, only to update a fully finalized user. 
         * @param {UpdateUserInfoRequest} updateUserInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthUserInfoUpdatePut: async (updateUserInfoRequest: UpdateUserInfoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserInfoRequest' is not null or undefined
            assertParamExists('apiV0AuthUserInfoUpdatePut', 'updateUserInfoRequest', updateUserInfoRequest)
            const localVarPath = `/api/v0/auth/user/info/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Resend code that was triggered in previous call to `sendCode` endpoint. It can also be used for account recovery.  - To recover a user with a given phone number using their email: resend with `UserKey` of `UserWithPhone` and  a verification method of `VerifyByEmail`  - To recover a user with a given email using their phone number: resend with `UserKey` of `UserWithEmail` and  a verification method of `VerifyByPhone`
         * @param {ResendCodeRequest} resendCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AuthCodeResendPost(resendCodeRequest: ResendCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AuthCodeResendPost(resendCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AuthCodeResendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start email/phone number verification. The endpoint takes in an email or phone number and will trigger a  verification code to be sent to user. The endpoint returns a `authStateToken`. Pass the  `authStateToken` along with the verification code that was sent to their email/phone number to  the `createSession` endpoint to receive a session for the user associated with that email or phone number.  Should not be automatically retried because it is not idempotent  
         * @param {SendCodeRequest} sendCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AuthCodeSendPost(sendCodeRequest: SendCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AuthCodeSendPost(sendCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AuthCodeSendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verify user identity through an authentication method. if verification is successful the session cookie will be updated.  may result in switching to another user or merging the anonymous session into an existing user. For example:  session cookie on call is anonymous user -> merges anonymous user into the verified user. replaces session cookie.  session cookie on call is verified user -> replace session cookie with new verified user  no session cookie -> failure  If `FinalizedRequired` is returned, finalize user with finalizeUser endpoint then get createSession with  returned `authStateToken`.
         * @param {CreateSessionRequest} createSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AuthSessionCreatePost(createSessionRequest: CreateSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AuthSessionCreatePost(createSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AuthSessionCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get information on current session 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AuthSessionInfoPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSessionInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AuthSessionInfoPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AuthSessionInfoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refreshes session cookie 
         * @param {RefreshSessionRequest} refreshSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AuthSessionRefreshPut(refreshSessionRequest: RefreshSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefreshSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AuthSessionRefreshPut(refreshSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AuthSessionRefreshPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Perform log out for the current session. Removes session cookie. The createSession endpoint should be called right after log out so the user then has an anonymous user session to use the site. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AuthSessionRemovePut(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoveSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AuthSessionRemovePut(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AuthSessionRemovePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Finalize user by adding user information that was specified in createSession request
         * @param {FinalizeUserRequest} finalizeUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AuthUserFinalizePost(finalizeUserRequest: FinalizeUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinalizeUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AuthUserFinalizePost(finalizeUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AuthUserFinalizePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the core user properties. Should not be used to transition  user state, only to update a fully finalized user. 
         * @param {UpdateUserInfoRequest} updateUserInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AuthUserInfoUpdatePut(updateUserInfoRequest: UpdateUserInfoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUserInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AuthUserInfoUpdatePut(updateUserInfoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AuthUserInfoUpdatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Resend code that was triggered in previous call to `sendCode` endpoint. It can also be used for account recovery.  - To recover a user with a given phone number using their email: resend with `UserKey` of `UserWithPhone` and  a verification method of `VerifyByEmail`  - To recover a user with a given email using their phone number: resend with `UserKey` of `UserWithEmail` and  a verification method of `VerifyByPhone`
         * @param {ResendCodeRequest} resendCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthCodeResendPost(resendCodeRequest: ResendCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResendCodeResponse> {
            return localVarFp.apiV0AuthCodeResendPost(resendCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Start email/phone number verification. The endpoint takes in an email or phone number and will trigger a  verification code to be sent to user. The endpoint returns a `authStateToken`. Pass the  `authStateToken` along with the verification code that was sent to their email/phone number to  the `createSession` endpoint to receive a session for the user associated with that email or phone number.  Should not be automatically retried because it is not idempotent  
         * @param {SendCodeRequest} sendCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthCodeSendPost(sendCodeRequest: SendCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendCodeResponse> {
            return localVarFp.apiV0AuthCodeSendPost(sendCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify user identity through an authentication method. if verification is successful the session cookie will be updated.  may result in switching to another user or merging the anonymous session into an existing user. For example:  session cookie on call is anonymous user -> merges anonymous user into the verified user. replaces session cookie.  session cookie on call is verified user -> replace session cookie with new verified user  no session cookie -> failure  If `FinalizedRequired` is returned, finalize user with finalizeUser endpoint then get createSession with  returned `authStateToken`.
         * @param {CreateSessionRequest} createSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthSessionCreatePost(createSessionRequest: CreateSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateSessionResponse> {
            return localVarFp.apiV0AuthSessionCreatePost(createSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get information on current session 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthSessionInfoPost(options?: RawAxiosRequestConfig): AxiosPromise<GetSessionInfoResponse> {
            return localVarFp.apiV0AuthSessionInfoPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Refreshes session cookie 
         * @param {RefreshSessionRequest} refreshSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthSessionRefreshPut(refreshSessionRequest: RefreshSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<RefreshSessionResponse> {
            return localVarFp.apiV0AuthSessionRefreshPut(refreshSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Perform log out for the current session. Removes session cookie. The createSession endpoint should be called right after log out so the user then has an anonymous user session to use the site. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthSessionRemovePut(options?: RawAxiosRequestConfig): AxiosPromise<RemoveSessionResponse> {
            return localVarFp.apiV0AuthSessionRemovePut(options).then((request) => request(axios, basePath));
        },
        /**
         * Finalize user by adding user information that was specified in createSession request
         * @param {FinalizeUserRequest} finalizeUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthUserFinalizePost(finalizeUserRequest: FinalizeUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<FinalizeUserResponse> {
            return localVarFp.apiV0AuthUserFinalizePost(finalizeUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the core user properties. Should not be used to transition  user state, only to update a fully finalized user. 
         * @param {UpdateUserInfoRequest} updateUserInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AuthUserInfoUpdatePut(updateUserInfoRequest: UpdateUserInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateUserInfoResponse> {
            return localVarFp.apiV0AuthUserInfoUpdatePut(updateUserInfoRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Resend code that was triggered in previous call to `sendCode` endpoint. It can also be used for account recovery.  - To recover a user with a given phone number using their email: resend with `UserKey` of `UserWithPhone` and  a verification method of `VerifyByEmail`  - To recover a user with a given email using their phone number: resend with `UserKey` of `UserWithEmail` and  a verification method of `VerifyByPhone`
     * @param {ResendCodeRequest} resendCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AuthCodeResendPost(resendCodeRequest: ResendCodeRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AuthCodeResendPost(resendCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start email/phone number verification. The endpoint takes in an email or phone number and will trigger a  verification code to be sent to user. The endpoint returns a `authStateToken`. Pass the  `authStateToken` along with the verification code that was sent to their email/phone number to  the `createSession` endpoint to receive a session for the user associated with that email or phone number.  Should not be automatically retried because it is not idempotent  
     * @param {SendCodeRequest} sendCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AuthCodeSendPost(sendCodeRequest: SendCodeRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AuthCodeSendPost(sendCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify user identity through an authentication method. if verification is successful the session cookie will be updated.  may result in switching to another user or merging the anonymous session into an existing user. For example:  session cookie on call is anonymous user -> merges anonymous user into the verified user. replaces session cookie.  session cookie on call is verified user -> replace session cookie with new verified user  no session cookie -> failure  If `FinalizedRequired` is returned, finalize user with finalizeUser endpoint then get createSession with  returned `authStateToken`.
     * @param {CreateSessionRequest} createSessionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AuthSessionCreatePost(createSessionRequest: CreateSessionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AuthSessionCreatePost(createSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get information on current session 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AuthSessionInfoPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AuthSessionInfoPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refreshes session cookie 
     * @param {RefreshSessionRequest} refreshSessionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AuthSessionRefreshPut(refreshSessionRequest: RefreshSessionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AuthSessionRefreshPut(refreshSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Perform log out for the current session. Removes session cookie. The createSession endpoint should be called right after log out so the user then has an anonymous user session to use the site. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AuthSessionRemovePut(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AuthSessionRemovePut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Finalize user by adding user information that was specified in createSession request
     * @param {FinalizeUserRequest} finalizeUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AuthUserFinalizePost(finalizeUserRequest: FinalizeUserRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AuthUserFinalizePost(finalizeUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the core user properties. Should not be used to transition  user state, only to update a fully finalized user. 
     * @param {UpdateUserInfoRequest} updateUserInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AuthUserInfoUpdatePut(updateUserInfoRequest: UpdateUserInfoRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AuthUserInfoUpdatePut(updateUserInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



